import { useState } from "react";
import { requestAdminAPI } from "../../api/posh-api";
import Modal from "../UI/Modal";
import Heading from "../UI/Heading";
import DetailPair from "../UI/DetailPair";
import SelectPair from "../UI/SelectPair";
import LoadingSpinner from "../UI/LoadingSpinner";
import { MdClose } from "react-icons/md";

/** ========================================================================
 * * ADD BANK ACCOUNT MODAL
 * ========================================================================== */
export default function AddBankAccount({ partnerId, open, setOpen, refresh }) {
  const [loading, setLoading] = useState(false);

  const submitHandler = async () => {
    try {
      setLoading(true);
      const payload = {
        partnerId,
        bank: document.getElementById("bank").value,
        account: document.getElementById("account").value,
        routing: document.getElementById("routing").value,
        type: document.getElementById("type").value,
      };

      // Call API to add bank account
      await requestAdminAPI("add-partner-bank", payload);

      // Refresh list so the new account is visible
      if (typeof refresh === "function") {
        await refresh();
      }

      // Close modal so user sees the updated list and cleared form on next open
      setOpen(false);

      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };
  return (
    <Modal open={open} setOpen={setOpen}>
      <div className="modal max-w-[600px]">
        <Heading
          title="Add Bank Account"
          isBackArrow={false}
          text="Use this form to add a partner's bank account information for payouts."
        >
          <MdClose className="icon" onClick={() => setOpen(false)} />
        </Heading>
        <div className="info lg:grid-cols-2">
          <DetailPair
            label="Complete Bank Name"
            edit={true}
            inputOptions={{
              id: "bank",
            }}
          />
          <DetailPair
            label="Account Number"
            edit={true}
            inputOptions={{
              id: "account",
            }}
          />
          <DetailPair
            label="Routing Number"
            edit={true}
            inputOptions={{
              id: "routing",
            }}
          />
          <SelectPair
            label="Type"
            edit={true}
            options={["Checking", "Savings"]}
            inputOptions={{
              id: "type",
            }}
          />
          {loading ? (
            <LoadingSpinner />
          ) : (
            <div className="btn-primary" onClick={submitHandler}>
              Confirm
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
}
